<script>
import { BCardBody } from "bootstrap-vue";

export default {
  extends: BCardBody
};
</script>